// src/services/carService.js

import axios from 'axios';

const API_URL = 'https://therentalz.thetrippingcompany.com/api/getCars'; // Update this with your actual API URL

// Function to fetch cars data from the API
export const fetchCars = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data; // Return the cars data if the request is successful
  } catch (error) {
    console.error('Error fetching car data:', error);
    throw error; // Re-throw error to be handled by the component
  }
};
